import React,{useState} from 'react';
import '../App.css';
import RenderPdf from '../utils/RenderPdf.js';
import {FaArrowLeft, FaArrowRight, FaFileDownload,FaTelegramPlane} from 'react-icons/fa';
import {AiFillHome} from 'react-icons/ai';//,AiOutlineSend
import {AllExperiments,ActiveExperiments, EMAIL, ENDPOINT} from '../utils/Constants.js';
import VideoChat from './VideoChat.js';
import TestForm from './TestForm.js';
//server endpoint
//import {ENDPOINT, EMAIL,ExpInstructions} from '../utils/Constants.js';
import ThankYou from './ThankYou.js';

function User(props){
/*
props{
    userInfo{
      username,
      userID,
      group (=avatar personality=roomNr:1 for openfriendlysociable, 2 for quietsadreclusive)
      surveyData (place:"holder" until first survey reply)
  },
   onChange()
  }
*/
//Participant webpage
  let {signedIn, userToken, userName, userID, email, role, timeSlot, participated,group} = props.userInfo;
  let [page,setPage]=useState("home")
  //pages to go through for the user. Will be changed on button click for experiment
  let [pages,setPages]=useState(["home"])
  let [isLoading, setIsLoading]=useState(false);
  let [loadError, setLoadError]=useState('');
  let [nextError,setNextError]=useState(false);
  let [startTime, setStartTime] =useState('');
  let [experiment,setExperiment] = useState('');
  //let [isLoadingT, setIsLoadingT]=useState(false);

  //template for collecting replies to each survey
  let repTemplate = {};
  //template for showing descriptions in each survey
  let desTemplate = {};
  let exKeys = Object.keys(AllExperiments);
  for (let i = 0; i < exKeys.length; i++) {
    repTemplate[exKeys[i]]={startTime:"", endTime:""};
    desTemplate[exKeys[i]]={};
    let parts = AllExperiments[exKeys[i]].parts;
    let types = AllExperiments[exKeys[i]].types;
    let pgs = AllExperiments[exKeys[i]].pages;
    for (let p=0; p<parts.length; p++){
      if (types[p]==="Form"){
        repTemplate[exKeys[i]][pgs[p]]= new Array(parts[p].data.length).fill('');
        desTemplate[exKeys[i]][pgs[p]]= new Array(parts[p].data.length).fill('No');
      }
    }
  }
  //state to collect all replies to each experiment's survey
  let [replies, setReplies]=useState({dummy:repTemplate})
  //state to show or hide descriptions
  let [showDescription,setShowDescription]=useState({dummy:desTemplate});
  let errorMessage = "This question is missing an answer. Please complete it to continue."
  //console.log("Pages: ",pages)
  //propagate state change up through hierarchy
  function handleChange(newInfo){
    props.onChange(newInfo)
  }

  function resetReplies(){
    setReplies({dummy:repTemplate})
  }
  //on server response change data
  function onResponseChangeState(message){
      setLoadError(message);
      setIsLoading(false);

  }
  //download the user's consent form
  function onConsentDL(){
    setIsLoading(true);
    fetch(ENDPOINT + '/api/account/getpdf',
    {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
        },
      body: JSON.stringify({
        email: email
        })
    })
    .then(res => res.json())
        .then(json => {
            if(json.success){
              //update App state to not loading
              onResponseChangeState('')
              RenderPdf(json.consentForm,"pdf")
            }
            else{
              onResponseChangeState(json.message)
            }
        });
  }
//integrate saved survey answers into current template if they've an entry in participated
  function integrateSurvey(data){
    let responses = repTemplate;
    Object.keys(participated).map((ex) =>{
      if (data.hasOwnProperty(ex)){
        console.log("Found data for ",ex)
        responses[ex]=data[ex];
      }
      else if ("startTime" in Object.keys(data)){
        console.log("Integrating data from ex1")
        responses["ex1"]=data;
      }
      else{
        console.log("How did you en up here? Experiment ",ex," found but no corresponding data saved.")
      }
      return responses
    });
    console.log("InitialReplies:",replies)
    setReplies({dummy:responses});
  }
  //retrieve current user's survey data from MongoDB
  function fetchSurvey(){
    setIsLoading(true);
    fetch(ENDPOINT + '/api/account/getsurvey',
    {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
        },
      body: JSON.stringify({
        email: email
        })
    })
    .then(res => res.json())
        .then(json => {
            if(json.success){
              //update App state
              onResponseChangeState('')
              if (json.surveyData.place !== "holder")
              {
                integrateSurvey(json.surveyData)
              }
            }
            else{
              onResponseChangeState(json.message)
            }
        });
  }
  //when clicking the navigation buttons below form, save partial survey data
  function updateSurvey(){
    setIsLoading(true);
    console.log("Updating the survey with replies: ",replies.dummy)
    fetch(ENDPOINT + '/api/account/hasparticipated',
    {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
        },
      body: JSON.stringify({
        userID:userID,
        participated:participated, //don't change the status of participation
        surveyData:replies.dummy
      })
    })
    .then(res => res.json())
        .then(json => {
            if(json.success){
              //update App state
              onResponseChangeState('')
              console.log("...was successful")
            }
            else{
              onResponseChangeState(json.message)
            }
        })
  }
  //when clicking the submit button
  function submitSurvey(){
    //update end time of current experiment in replies state
    let rep = replies.dummy;
    rep[experiment]["endTime"]=new Date().toUTCString();
    rep[experiment]["endTime"]=startTime;
    setReplies({dummy:rep});

    let part= participated;
    part[experiment]=true;

    console.log("Submission time:",rep[experiment]["endTime"])
    setIsLoading(true);
    console.log("Submitting the survey...")
    fetch(ENDPOINT + '/api/account/hasparticipated',
    {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
        },
      body: JSON.stringify({
        userID:userID,
        participated:part,
        surveyData:replies.dummy
        })
    })
    .then(res => res.json())
        .then(json => {
            if(json.success){
              //update App state
              onResponseChangeState('')
              console.log("...successfully")
              handleChange({
                signedIn:signedIn,
                userToken:userToken,
                userName:userName,
                userID:userID,
                email:email,
                role:role,
                timeSlot:timeSlot,
                participated:part,
                group:group
              });
            }
            else{
              onResponseChangeState(json.message)
            }
        });
    setPage("home");
    setExperiment("");
    setPages=(["home"]);
    toggleThx()
    resetErrors();
    resetReplies();
  }

  function onSurveyChange(event){
    //let formName=event.target.form

    let [exp,formName,index]=event.target.name.split(" ");
    index=parseInt(index);
    console.log("Old form entry:",formName,index,replies["dummy"][exp][formName][index]);
    let answer=event.target.value;
    let newRep=replies.dummy;
    newRep[exp][formName][index]=answer;
    setReplies({dummy:newRep});
    console.log("Updated form entry:",formName,index,replies["dummy"][exp][formName][index]);
  }
  //when clicking on the Start Experiment button
  function onParticipate(ex){
    console.log("onParticipate -> Parameter ex:", ex);
    setExperiment(ex);
    console.log("Experiment:", experiment);
    let part = participated;
    //if user hasn't done the experiment before, set participated[ex] to false
    if (part[ex] !== true){
      part[ex]=false;
      handleChange({
        signedIn:signedIn,
        userToken:userToken,
        userName:userName,
        userID:userID,
        email:email,
        role:role,
        timeSlot:timeSlot,
        participated:part,
        group:group
      });
    };
    setStartTime(new Date().toUTCString());
    setPages(pages.concat(AllExperiments[ex]["pages"]))
    fetchSurvey();
    setPage(AllExperiments[ex]["pages"][0]);
  }
  //toggle description visibility on personality questionnaire
  function onDescriptionChange(event){
    //let formName=event.target.form
    let [exp,formName,index]=event.target.name.split("_")
    index=parseInt(index)
    //console.log("Got to description show function, form name:",formName)
    console.log("Toggle description for form entry:",formName, index)
    let newDes=showDescription.dummy
    newDes[exp][formName][index]=newDes[exp][formName][index]==="No"?"Yes":"No";
    setShowDescription({dummy:newDes})
  }
  function toStartPage(){
    updateSurvey()
    setPage("home");
    setExperiment("");
    setPages(["home"]);
    resetErrors();
    resetReplies();
  }
  function incrementPage(){
    let pos=pages.indexOf(page);
    console.log("Current Position:",pos,page,"Pages:",pages,"Experiment:",experiment)

    if (replies["dummy"][experiment].hasOwnProperty(page)){
      console.log("We're on a survey page. Checking that all in completed...")
      updateSurvey()
      if (replies["dummy"][experiment][page].includes("")){
        console.log("Encountered Error, some replies missing.")
        setNextError(true);
      }
      else{
        console.log("No missing replies, let's move on to page ",pages[pos+1])
        setPage(pages[pos+1]);
        console.log("Next Page:",pages[pos+1])
        setNextError(false);
      }
    }
    else{
    console.log("Not a survey page. On to Page",pages[pos+1])
    setPage(pages[pos+1]);
    setNextError(false);
    }
  }
  function decrementPage(){
    let nextpos=pages.indexOf(page)-1;
    setPage(pages[nextpos])
  }
  //reset all error messages
  function resetErrors(){
    setLoadError('');
    setNextError(false);
  }

  let nextButton=()=>(
    <button
      className="surveyButton blue flexButton"
      onClick={incrementPage}
      style = {{visibility: page!==pages[pages.indexOf('home')]
                        && page!==pages[pages.length-1] ? "visible":"hidden"}}
      ><FaArrowRight/>
    </button>
  )
  let submitButton=()=>(
    <button
      className="textButton blue flexButton"
      onClick={submitSurvey}
      style = {{visibility: page!==pages[pages.indexOf('home')]
                        && page===pages[pages.length-1] ? "visible":"hidden"}}
      >Submit <FaTelegramPlane className="iconR"/>
    </button>
  )
  let backButton=()=>(
    <button
      className="surveyButton blue flexButton"
      onClick={decrementPage}
      //don't show on homepage and 1st experiment page
      style = {{visibility: page!==pages[pages.indexOf('home')]
                        //&& page!==pages[pages.indexOf('chat')]
                        && page!==pages[1] ? "visible":"hidden"}}
      ><FaArrowLeft/>
    </button>
  )
  let homeButton=()=>(
    <button
      className="surveyButton blue flexButton"
      onClick={toStartPage}
      style = {{visibility: page!==pages[pages.indexOf('home')]
                      //  && page!==pages[pages.indexOf('chat')]
                      ?"visible":"hidden"
                      }}
      ><AiFillHome/>
    </button>
  )
  //Survey Functions
  function surveyItem( idx, name, exp, data ){
    const {question,type} = data
    let currRep = replies["dummy"][exp][name][idx]
    //console.log("Rendering Survey Item",idx,", value:",currRep)
    if (type==="radio"){
      const {options}=data;
      //console.log(options)
      return(
        <div className="surveyItem">
        {data.description?
          <div className="popup">
            <div className="surveyPrompt"
              title = {data.description}
              onClick={onDescriptionChange}>
                {question}
                <input type="button" value="?" name={exp+"_"+name+"_"+idx} id={exp+"_"+name+"_"+idx} className="description-button"/>
            </div>
            {/*console.log("Show description:",idx,showDescription["dummy"][exp][name][idx])*/}
            <span className="popuptext" style={{visibility:showDescription["dummy"][exp][name][idx]==="Yes"?"visible":"hidden"}}>
              Definition: {data.description}
            </span>
          </div>
        :
          <div className="surveyPrompt">
            <label>{question}</label>
          </div>
        }
          <p className="error" style={{display:currRep==="" && nextError?"block":"none"}}>{errorMessage}</p>
          <div>
          {options.map((item,aID)=>
            <label className="radioLabel">
            {/*console.log("Option:",item,"Checked:",currRep===item)*/}
              <input
                type="radio"
                checked={currRep===item}
                value={item}
                name={exp+" "+name+" "+idx}
                onChange={onSurveyChange}
                id={name+"_"+idx+"_"+aID}/>{item}
            </label>)}
          </div>
        </div>
      )
    }
    else if (type==="scale"){
      const {options,start,end}=data;
      return(
        <div className="surveyItem">
        {data.description?
          <div className="popup">
            <div className="surveyPrompt"
              title = {data.description}
              onClick={onDescriptionChange}>
                {question}
                <input type="button" value="?" name={exp+"_"+name+"_"+idx} id={exp+"_"+name+"_"+idx} className="description-button"/>
            </div>
            {/*console.log("Show description:",idx,show==="Yes")*/}
            <span className="popuptext" style={{visibility:showDescription["dummy"][exp][name][idx]==="Yes"?"visible":"hidden"}}>
              Definition: {data.description}
            </span>
          </div>
        :
          <div className="surveyPrompt">
            <label>{question}</label>
          </div>
        }
          <p className="error" style={{display:currRep==="" && nextError?"block":"none"}}>{errorMessage}</p>
          <div onChange={onSurveyChange}>
          <span className="dark">{start}</span>
          {options.map((item,aID)=>
            <label key={"Lbl_"+exp+"_"+name+"_"+idx+"_"+aID} className="radioLabel">
              <input
                type="radio"
                checked={currRep===item}
                value={item}
                name={exp+" "+name+" "+idx}
                key={exp+"_"+name+"_"+idx+"_"+aID}/>{item}
            </label>)}
            <span className="dark">{end}</span>
          </div>
        </div>
      )
    }
    else if (type==="longText") {
      return(
        <div className="surveyItem">
          <div className="surveyPrompt">
            <label>{question}</label>
          </div>
          <p className="error" style={{display:currRep==="" && nextError?"block":"none"}}>{errorMessage}</p>
          <div>
            <textarea cols="80" rows="5"
              className="formTextInput"
              value={currRep}
              name={exp+" "+name+" "+idx}
              key={exp+"_"+name+"_"+idx}
              onChange={onSurveyChange}>
            </textarea>
          </div>
        </div>
      )
    }
    else if (type==="shortText") {
      //console.log("TextInput:",currRep)
      return(
        <div className="surveyItem" >
          <div className="surveyPrompt">
            <label>{question}</label>
          </div>
          <p className="error" style={{display:currRep==="" && nextError?"block":"none"}}>{errorMessage}</p>
          <div>
            <input type="text" className="formTextInput"
              value={currRep}
              name={exp+" "+name+" "+idx}
              key={exp+"_"+name+"_"+idx}
              onChange={onSurveyChange}/>
          </div>
        </div>
      )
    }
  }
  //

  function parseSurvey({survey,page,exp}){
    //let partIdx = AllExperiments[experiment]["parts"].indexOf(part)
    //let survey = AllExperiments[experiment]["parts"][partIdx]
    //console.log("parsing Survey: ",survey)
    for (let i = 0; i < survey.data.length; i++) {
      if(survey.type){survey.data[i].type=survey.type;}
      if(survey.options){survey.data[i].options=survey.options;}
      if(survey.start){survey.data[i].start=survey.start;}
      if(survey.end){survey.data[i].end=survey.end;}
    }
    return(
      <div id="register" className='center' style={{display: "block"}}>
        <h1>{survey.title}</h1>
        {/*optionally with instructions, if included*/}
        <div className='instructions' style={{maxWidth: "600px",margin: "auto"}}>
        <div className="dark" style={{display: survey.instructions? "block" : "none"}}>{survey.instructions}</div>
        </div>
        {/*optionally with an error message, if something went wrong in a previous login
        <p className='error message' style={{display: signUpError!='' ? "block" : "none"}}>{signUpError}</p>*/}
        <div className="formContainer">
          <div className="formInnerContainer">
            {survey.data.map((item,index)=>(surveyItem( index, page, exp, item)))}
          </div>
        </div>
      </div>
    )
  }

  let HomePage=
  <div className="left" style={{maxWidth: "600px",margin: "auto"}}>
    <h1 className="title center">Welcome {userName}!</h1>
    <p style={{ fontWeight: 'bold' }} className="center">This is your personal page on ODE.</p>
    {/*<TestForm />*/}
    <p style={{ fontWeight: 'bold' }} className="center">Here, you can join an experiment or download your consent form that you completed on signing up.</p>
    <p><i>If you run into any difficulties or have a question during the experiment,
    please feel free to contact me at: <a href={"mailto:"+EMAIL}>{EMAIL}</a></i></p>
  </div>

  // Functions for user pages
  let startPage=()=>{
    return(
      <div className="center" >
        {HomePage}
        <p className="error" style={{display: loadError!=='' ? "block" : "none"}}>{loadError}.</p>
        <div className="row">
        {ActiveExperiments.map((ex)=>(
          <button
            style={{display: /*participated ? "none" : */"inline-block"}}
            className="textButton blue"
            onClick={()=>{onParticipate(ex)}}>Start {AllExperiments[ex]['name']}
          </button>))}
          <button
            className="textButton blue flexButton"
            onClick={onConsentDL}> Consent Form <FaFileDownload className="iconR"/>
          </button>
          <p style={{display: isLoading ? "block" : "none"}}>Retrieving your data...</p>
        </div>
      </div>
    )
  }

 function leavePage(newPage){
    setPage(newPage)
  }
//for WOZ, talk to avatar via videochat
  let videoChatPage=()=>{
    return(
      <div className="center" >
        <h1 className="title">VideoChat</h1>
        <VideoChat userInfo={props.userInfo} nextPage={pages[pages.indexOf('chat')+1]} onChange={leavePage}/>
        {/*<h2 className="title">Below Video Chat</h2>*/}
      </div>
    )
  }

//create ThankYou modal
  const UseThx = () => {
    const [showThx, setShowThx] = useState(false);
    function toggleThx() {
      setShowThx(!showThx);
    }
    return {
      showThx,
      toggleThx,
    }
  };

  const {showThx, toggleThx} = UseThx();

  return(

    <div className='center'>
      {
        page==="home"?startPage()
        :AllExperiments[experiment]["types"][AllExperiments[experiment]["pages"].indexOf(page)]==="HTML"?
          AllExperiments[experiment]["parts"][AllExperiments[experiment]["pages"].indexOf(page)]
        :AllExperiments[experiment]["types"][AllExperiments[experiment]["pages"].indexOf(page)]==="HTMLByGroup"?
          AllExperiments[experiment]["parts"][AllExperiments[experiment]["pages"].indexOf(page)][group-1]
        :AllExperiments[experiment]["types"][AllExperiments[experiment]["pages"].indexOf(page)]==="Form"?
          parseSurvey({survey:AllExperiments[experiment]["parts"][AllExperiments[experiment]["pages"].indexOf(page)],page:page, exp:experiment})
        :AllExperiments[experiment]["types"][AllExperiments[experiment]["pages"].indexOf(page)]==="VideoChat"?
          videoChatPage()
        : startPage()
      }
      <div className="bottom-nav flexButton">
        <div className="navbar-left center">
          {backButton()}
        </div>
        <div className="navbar-center center">
          {homeButton()}
        </div>
        <div className="navbar-right center">
          {page===pages[pages.length-1]?submitButton():nextButton()}
        </div>
      </div>
      <a id="pdf" href="/"> </a>
      <ThankYou isShowing={showThx} hide={toggleThx}/>
    </div>
  )
}

export default User
